var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLobstrLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 11,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.334 2.787C3.827 1.683 4.712.67 5.356 0 2.516.792 0 4.574 0 6.874 0 9.304 1.85 11 4.5 11S9 9.303 9 6.874c0-1.832-.97-3.783-2.253-4.677-.094 1.215-.67 2.566-1.571 3.61a5.984 5.984 0 01-.728.715c-.41.337-.847.6-1.3.783l-.42.17-.099-.453c-.061-.281.005-2.67.705-4.235z",
    fill: "#fff"
  })));
}
export default SvgLobstrLogo;